import etiLogo from "assets/images/etiLogo.jpg";

export default {
  brand: {
    name: "ETI at GW Law",
    image: etiLogo,
    route: "/",
  },
};
